export default function updateTplName() {

    tinymce.PluginManager.add('updateTplName', function (editor, url) {
        var openDialog = function () {
            return editor.windowManager.open({
                title: '设置模板名称',
                body: {
                    type: 'panel',
                    items: [
                        {
                            type: 'input',
                            name: 'title',
                            label: '模板名称'
                        }
                    ]
                },
                buttons: [
                    {
                        type: 'cancel',
                        text: 'Close'
                    },
                    {
                        type: 'submit',
                        text: 'Save',
                        primary: true
                    }
                ],
                onSubmit: function (api) {
                    var data = api.getData();
                    document.getElementById("tpl_name").value = data.title
                    editor.notificationManager.open({
                        text: '名称已经变更，您需要点击底部保存内容后生效',
                        type: 'success',
                        timeout: 3000
                    });
                    api.close();
                }
            });
        };


        // 注册一个工具栏按钮名称
        editor.ui.registry.addButton('updateTplNameButton', {
            icon: 'edit-block',
            tooltip: '设置模板名称',
            onAction: function (...e) {
                openDialog(e);
                setTimeout(function () {
                    document.querySelector(".tox-textfield").value =  document.getElementById("tpl_name").value
                })
            }
        });
        return {
            getMetadata: function () {
                return  {
                    name: "updateTplName",
                    url: "http://www.1dq.com",
                };
            }
        };
    });

}